module.exports = __webpack_public_path__ + "static/media/filter-light.50fdf628.svg";